<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">

                <div class=" container-lg  base-header__container ">
                    <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                        <ul class="nav ">
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/guide/basic-info">Шта је Правно-информациони
                                    систем?
                                </router-link>
                            </li>
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/guide/how-to">Упутство за коришћење</router-link>
                            </li>
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/guide/customer-service">Техничка подршка
                                </router-link>
                            </li>
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/guide/qa">Питања и одговори</router-link>
                            </li>
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/guide/other">Остало</router-link>
                            </li>


                        </ul>
                        <h1 class="base-header__title">
                            <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
                            Водич
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <iframe :src="baseApiUrl + pageData" :key="pageData" width="100%" height="600px" frameborder="0"></iframe>
                <!--                <iframe :key ="baseApiUrl + pageData" width="100%" height="600px" frameborder="0"></iframe>-->
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "GuidePage",
    data() {
        return {
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            }
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        pageData() {
            let pageData = null;

            // basic-info
            // how-to
            // customer-service
            // qa
            // other
            switch (this.$route.params.page) {
                case 'basic-info':
                    // code block
                    pageData = 'prins/GetStaticPageByCode/RSB0101';
                    break;
                case 'how-to':
                    // code block
                    pageData = 'prins/GetStaticPageByCode/RSB0103';
                    break;
                case 'customer-service':
                    // code block
                    pageData = 'prins/GetStaticPageByCode/MM0302';
                    break;
                case 'qa':
                    // code block
                    pageData = 'prins/GetStaticPageByCode/MM0301';
                    break;
                case 'other':
                    // code block
                    pageData = 'prins/GetStaticPageByCode/RSB05';
                    break;
                default:
                // code block
            }
            return pageData;
        }
    },
    mounted() {
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style>
.main {
    background-color: #ddd !important;
    padding-bottom: 360px !important;
}
</style>
